Vue.directive('focus', require('./directives/Focus.vue'));


// WEBPACK FOOTER //
// ./resources/js/src/directives.js